export type InfoMessageModel = {
  infoType: "ERROR" | "ALERT"
  infoMessage: string
  clickableMessage?: string
  onClick?: () => void
}

export const MessageMaxLength = {
  OTP_SCREN: 300,
  LOGIN_SCREEN: 650,
  CARD_LIST_SCREEN: 200,
  NEW_USER_SCREEN: 100,
  ADD_CARD_SCREEN: 100,
  CHANGE_OTP_CHANNEL: 250,
} as const
